// Konfigurowalne źródła kafli map. Domyślnie OpenStreetMap (dane ODbL —
// wolne do użytku komercyjnego pod warunkiem atrybucji). Dostawcy komercyjni
// (własny serwer kafli, MapTiler, Mapbox, Esri z kluczem) konfigurowani są
// w Ustawieniach → Mapa, dzięki czemu każda firma ISP używa własnej licencji.
export const OSM_TILE_URL = "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png";
export const OSM_ATTR = "© OpenStreetMap contributors";

export function resolveBaseLayers(settings = {}) {
  const url = (settings.map_tile_url || "").trim() || OSM_TILE_URL;
  const attr = (settings.map_tile_attribution || "").trim() || OSM_ATTR;
  const satUrl = (settings.map_sat_url || "").trim();
  const satAttr = (settings.map_sat_attribution || "").trim() || "© dostawca zdjęć satelitarnych";
  const layers = {
    dark: { url, cls: "tiles-dark", attr },
    osm: { url, cls: "", attr },
  };
  if (satUrl) layers.sat = { url: satUrl, cls: "", attr: satAttr };
  return layers;
}

export function tileSubdomains(url) {
  return (url || "").includes("{s}") ? ["a", "b", "c"] : [];
}
